import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuHierarchy, (menuParent, index) => {
        return (_openBlock(), _createElementBlock("div", {
            key: menuParent.id
        }, [
            (menuParent.isLink)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: _normalizeClass([
                        menuParent.class,
                        $setup.isShortLengthsOverview ? '!bg-gray-50' : '',
                        'hover:bg-gray-50 flex w-full items-center gap-x-[15px] py-1 text-left text-sm/6 font-semibold !text-gray-700 bg-none',
                    ]),
                    onClick: _cache[0] || (_cache[0] = _withModifiers(async () => {
                        await $setup.router.push({
                            query: {
                                remainders: '1',
                                startIndex: 1,
                            },
                        });
                    }, ["prevent"]))
                }, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "size-2 shrink-0" }, null, -1 /* CACHED */)),
                    _createTextVNode(" " + _toDisplayString(menuParent.name), 1 /* TEXT */)
                ], 2 /* CLASS */))
                : (_openBlock(), _createBlock($setup["Disclosure"], {
                    key: 1,
                    as: "div",
                    class: _normalizeClass(menuParent.class),
                    defaultOpen: menuParent.id == $setup.route.query.articleGrouping ||
                        menuParent.children.some((menuChild) => menuChild.id === $setup.route.query[menuChild.queryName])
                }, {
                    default: _withCtx(({ open }) => [
                        _createVNode($setup["DisclosureButton"], {
                            class: "hover:bg-gray-50 flex w-full items-center gap-x-[15px] py-1 text-left text-sm/6 font-semibold !text-gray-700",
                            ref_for: true,
                            ref: (element) => {
                                $setup.itemsRefs[index] = {
                                    id: menuParent.id,
                                    element,
                                    isOpen: open,
                                };
                            }
                        }, {
                            default: _withCtx(() => [
                                _createVNode($setup["ChevronDownIcon"], {
                                    class: _normalizeClass([open ? 'rotate-180 transform' : '', "text-gray-500 size-2 shrink-0"])
                                }, null, 8 /* PROPS */, ["class"]),
                                _createTextVNode(" " + _toDisplayString(menuParent.name), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1536 /* NEED_PATCH, DYNAMIC_SLOTS */),
                        _withDirectives(_createVNode($setup["DisclosurePanel"], {
                            static: "",
                            class: "p-4 pt-2 text-sm text-gray-500"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuParent.children, (menuChild) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                        class: _normalizeClass(`hover:bg-gray-50 ${menuChild.id === $setup.route.query[menuChild.queryName] ? '!bg-gray-50' : ''} !text-gray-700 block py-1 pr-2 text-sm/6 font-normal bg-none`),
                                        onClick: _withModifiers(async () => {
                                            await $setup.router.push({
                                                query: {
                                                    [menuChild.queryName]: menuChild.id,
                                                },
                                            });
                                        }, ["prevent"])
                                    }, _toDisplayString(menuChild.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_1));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1536 /* NEED_PATCH, DYNAMIC_SLOTS */), [
                            [_vShow, open]
                        ])
                    ]),
                    _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "defaultOpen"]))
        ]));
    }), 128 /* KEYED_FRAGMENT */));
}
